var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"cardLeft",attrs:{"xs12":"","sm12":"","md12":"","lg6":"","align-center":""}},[_c('v-img',{staticClass:"logoImage",attrs:{"contain":"","src":require('../../../assets/login.png')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }